import { render, staticRenderFns } from "./ReceiptCodeDetails.vue?vue&type=template&id=0a99d798&"
import script from "./ReceiptCodeDetails.vue?vue&type=script&lang=ts&"
export * from "./ReceiptCodeDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports